import { createActionTypes } from 'components/utility/actions';
export const types = createActionTypes([
	'FETCH_COMPONENTS',
	'FETCH_COMPONENTS_SUCCESS',
	'FETCH_COMPONENTS_ERROR',
	'INSTALL_CLEAR',
	'INSTALL_CANCEL',
	'OPERATION_UPDATE',
	'OPERATION_STOP',
	'OPERATION_START'
]);

export const fetchComponents = () => ({ type: types.FETCH_COMPONENTS });

/* Install operation specific Actions */
// Close the plugin install dialog
export const clearInstall = () => ({ type: types.INSTALL_CLEAR });

// Cancel plugin installation
export const installCancel = () => ({ type: types.INSTALL_CANCEL });

/* Shared operation Actions - for both install/uninstall operations. */
export const startOperation = (packageName, operation) => ({
	type: types.OPERATION_START,
	payload: {
		packageName,
		operation
	}
});

export const operationUpdate = payload => ({
	type: types.OPERATION_UPDATE,
	payload: {
		operation: payload.operation,
		log: payload.log || '',
		status: payload.status,
		name: payload.name,
		configFile: payload.configFile
	}
});

export const operationError = payload => ({
	type: types.OPERATION_UPDATE,
	payload: {
		operation: payload.operation,
		log: `\n${payload.error.stack}`,
		status: 'failed',
		name: payload.name
	}
});

export const operationStop = name => ({ type: types.OPERATION_STOP, payload: name });
